import { render, staticRenderFns } from "./RtnPartMstPopupTable2.vue?vue&type=template&id=529736d2&"
import script from "./RtnPartMstPopupTable2.vue?vue&type=script&lang=js&"
export * from "./RtnPartMstPopupTable2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports